/**
 * House of Places — "Search by city" box above "Browse places".
 *
 * Empty box: the country rows. Typing: the countries whose name contains the
 * text, plus up to 6 posters found live through Shopify's search (every
 * product, not a prebuilt list). Enter submits the box's own form — a plain
 * storefront search.
 *
 * The listener runs in the capture phase on the document and stops the event
 * there, so Dawn's facet form never re-renders the grid while typing.
 */
(function () {
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-city-filter']) return;
  yuklu['hop-city-filter'] = true;

  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  var seq = 0;
  var timer = null;

  function yerAdi(title) {
    return String(title || '').split(/\s+Travel Poster/i)[0].trim();
  }

  function ekle(ray, kutu, liste, q) {
    ray.querySelectorAll('[data-hop-injected]').forEach(function (n) {
      n.remove();
    });
    var nav = ray.querySelector('.hop-city-list');
    if (!nav || !liste.length) return;
    liste.slice(0, 6).forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'hop-city-item hop-city-item--city';
      a.setAttribute('data-hop-injected', '');
      a.href = String(p.url).split('?')[0];
      a.textContent = yerAdi(p.title);
      nav.insertBefore(a, nav.firstChild);
    });
    var bos = ray.querySelector('[data-hop-city-empty]');
    if (bos) bos.hidden = true;
  }

  function suz(kutu) {
    var aranan = norm(kutu.value);
    var sikisik = aranan.replace(/ /g, '');
    var ray = kutu.closest('[data-hop-place-rail]');
    if (!ray) return;
    var bulunan = 0;
    ray.querySelectorAll('[data-hop-injected]').forEach(function (n) {
      n.remove();
    });
    ray.querySelectorAll('.hop-city-item').forEach(function (satir) {
      var metin = norm(satir.textContent);
      var eslesti = metin.indexOf(aranan) !== -1 || metin.replace(/ /g, '').indexOf(sikisik) !== -1;
      var goster = aranan === '' ? true : eslesti;
      satir.hidden = !goster;
      if (goster) bulunan++;
    });
    var bos = ray.querySelector('[data-hop-city-empty]');
    if (bos) bos.hidden = aranan === '' || bulunan > 0;

    clearTimeout(timer);
    if (aranan.length < 2) return;
    var mine = ++seq;
    var q = kutu.value.trim();
    timer = setTimeout(function () {
      var base = window.routes && window.routes.predictive_search_url ? window.routes.predictive_search_url : '/search/suggest';
      fetch(
        base +
          '.json?q=' +
          encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,tag',
        { headers: { Accept: 'application/json' } }
      )
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (j) {
          if (!j || mine !== seq || kutu.value.trim() !== q) return;
          var liste = (j.resources && j.resources.results && j.resources.results.products) || [];
          ekle(ray, kutu, liste, q);
        })
        .catch(function () {});
    }, 180);
  }

  document.addEventListener(
    'input',
    function (e) {
      var kutu = e.target.closest && e.target.closest('[data-hop-city-filter]');
      if (!kutu) return;
      e.stopPropagation();
      suz(kutu);
    },
    true
  );
})();
